import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getProgressPercent } from '../helpers';
import classes from './index.module.scss';

const Bar = ({
    percent,
    className: customClassName,
    progressClassName: customProgressClassName,
    thresholdClassName: customThresholdClassName,
    backgroundClassName: customBackgroundClassName,
    limitsClassName: customLimitsClassName,
    fill,
    threshold,
    label,
    limits
}) => {
    const progressWidth = getProgressPercent(percent);
    const className = classnames(
        classes.progressbar,
        customClassName
    );
    const progressClassName = classnames(
        classes.progressFill,
        customProgressClassName
    );
    const backgroundClassName = classnames(
        classes.background,
        customBackgroundClassName
    );
    const thresholdClassName = classnames(
        classes.thresholdMarker,
        customThresholdClassName
    );
    const limitsClassName = classnames(
        classes.limit,
        customLimitsClassName
    );
    const fillStyle = {
        width: `${progressWidth}%`
    };

    fill && Object.assign(fillStyle, {
        backgroundColor: fill
    });

    return (
        <div className={className}>
            {
                limits &&
                <span className={classnames(limitsClassName, classes.limitMin)}>
                    { limits.min }
                </span>
            }
            <div className={backgroundClassName}>
                {
                    threshold &&
                    <span className={thresholdClassName} style={{ left: `${threshold}%` }}/>
                }
                <span className={progressClassName} style={fillStyle}/>
            </div>
            {
                label &&
                <span className={classes.thresholdLabel}
                    style={{ left: `${progressWidth}%` }}>
                    {label}
                </span>
            }
            {
                limits &&
                <span className={classnames(limitsClassName, classes.limitMax)}>
                    { limits.max }
                </span>
            }
        </div>
    );
};

Bar.propTypes = {
    percent: PropTypes.number.isRequired,
    className: PropTypes.string,
    progressClassName: PropTypes.string,
    thresholdClassName: PropTypes.string,
    limitsClassName: PropTypes.string,
    backgroundClassName: PropTypes.string,
    fill: PropTypes.string,
    threshold: PropTypes.number,
    label: PropTypes.string,
    limits: PropTypes.shape({
        min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        max: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
};

export default Bar;
